import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5ab70b8f&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=5ab70b8f&prod&scoped=true&lang=css&external"
import style1 from "./Menu.vue?vue&type=style&index=1&id=5ab70b8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab70b8f",
  null
  
)

export default component.exports